import type { DemoScript } from "../types";
import { DASHBOARD_SCRIPT_COPY } from "./dashboard-script.copy";

export const buildDashboardScript = (): DemoScript => [
  {
    id: "dash-intro",
    narrative: DASHBOARD_SCRIPT_COPY.dashIntro.narrative,
    durationMs: 3000,
  },
  {
    id: "dash-greeting",
    narrative: DASHBOARD_SCRIPT_COPY.dashGreeting.narrative,
    zoomTargetId: "dashboard-greeting",
    callout: {
      targetId: "dashboard-greeting",
      text: DASHBOARD_SCRIPT_COPY.dashGreeting.callout,
    },
    durationMs: 5200,
  },
  {
    id: "dash-overview-1",
    narrative: DASHBOARD_SCRIPT_COPY.dashOverview1.narrative,
    durationMs: 1800,
  },
  {
    id: "dash-social",
    narrative: DASHBOARD_SCRIPT_COPY.dashSocial.narrative,
    zoomTargetId: "dashboard-social-metrics",
    callout: {
      targetId: "dashboard-social-metrics",
      text: DASHBOARD_SCRIPT_COPY.dashSocial.callout,
    },
    durationMs: 5400,
  },
  {
    id: "dash-overview-2",
    narrative: DASHBOARD_SCRIPT_COPY.dashOverview2.narrative,
    durationMs: 1800,
  },
  {
    id: "dash-kpis",
    narrative: DASHBOARD_SCRIPT_COPY.dashKpis.narrative,
    zoomTargetId: "dashboard-kpis",
    callout: {
      targetId: "dashboard-kpis",
      text: DASHBOARD_SCRIPT_COPY.dashKpis.callout,
    },
    durationMs: 5400,
  },
  {
    id: "dash-overview-3",
    narrative: DASHBOARD_SCRIPT_COPY.dashOverview3.narrative,
    durationMs: 1800,
  },
  {
    id: "dash-posts",
    narrative: DASHBOARD_SCRIPT_COPY.dashPosts.narrative,
    zoomTargetId: "dashboard-week-posts",
    callout: {
      targetId: "dashboard-week-posts",
      text: DASHBOARD_SCRIPT_COPY.dashPosts.callout,
    },
    durationMs: 5400,
  },
  {
    id: "dash-agenda",
    narrative: DASHBOARD_SCRIPT_COPY.dashAgenda.narrative,
    zoomTargetId: "dashboard-agenda",
    callout: {
      targetId: "dashboard-agenda",
      text: DASHBOARD_SCRIPT_COPY.dashAgenda.callout,
    },
    durationMs: 5200,
  },
];
